export default __webpack_public_path__ + "static/begeisterung-22251e3e1aa525dd3ee8381568cbd74c.jpg";